export default function BrandStory() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8">
      <div className="max-w-[800px] mx-auto text-center">
        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">关于51影视</h1>
        <p className="text-sm text-foreground-500 mb-8">免费高清流畅观影，让每一部好作品都不被错过</p>
        <div className="text-left space-y-4 text-sm text-foreground-700 leading-relaxed">
          <p>
            <strong className="text-foreground-900">51影视网</strong>成立于2020年，是一家专注于提供<strong>免费影视在线观看</strong>服务的平台。我们致力于为广大影视爱好者打造一个
            <strong>高清不卡顿</strong>、<strong>不缓冲流畅</strong>的在线观影环境，让每一位用户都能享受到极致的观影体验。
          </p>
          <p>
            自成立以来，51影视网始终坚持"用户至上、内容为王"的运营理念。我们的内容团队每天24小时不间断更新，确保热播剧集、院线大片、高分佳作在第一时间与观众见面。
            目前平台已积累超过<strong className="text-primary-600">20000部</strong>影视资源，涵盖科幻、动作、奇幻、爱情、悬疑、喜剧等多种类型。
          </p>
          <p>
            在技术层面，51影视网投入大量资源建设了先进的视频分发网络。通过智能CDN加速和自适应码率技术，我们实现了<strong className="text-primary-600">99.9%的流畅播放率</strong>，
            让用户无论身处何地、使用何种设备，都能享受到<strong>高清不缓冲</strong>的观影体验。
          </p>
          <p>
            展望未来，51影视网将继续深耕影视领域，不断丰富内容库，优化用户体验。我们相信，好的影视作品值得被更多人看到，而我们要做的，
            就是搭建一座连接好作品与观众之间的桥梁。
          </p>
        </div>
      </div>
    </section>
  );
}